<template>
  <layout>
    <template v-slot:header>
      <AppHead title="System Settings" />
      <h2>System Settings</h2>
      <flash-messages />
    </template>
        
    <template v-slot:breadcrumbs>
      <BreadCrumbs activeItem="Settings" :crumbs="{ home: 'Dashboard' }"/>
    </template>
        
    <template v-slot:default>
      <div class="table-responsive">
        <table class="table table-striped tbody-border">
          <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in this.settings" :key="item.key">
            <td>{{ item.key }}</td>
            <td>
              <input type="text" v-model="item.value" class="form-control" @blur="updateSetting($event, item)" @keyup.enter="$event.target.blur()"/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <section class="mt-3">
        <h3>Warehouses</h3>

        <div class="table-responsive">
          <table class="table table-striped tbody-border">
            <thead>
            <tr>
              <th>ID</th>
              <th>Address</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="address in this.warehouses">
              <td>{{ address.id }}</td>
              <td>{{ address.company_name }} {{ address.address1 }} {{ address.city }}, {{ address.state }} {{ address.postcode }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="mt-3">
        <h3>New Warehouse / Product Source Location</h3>

        <div class="row">
          <div class="form-group col-sm-6">
            <jet-label for="address1" value="Address" />
            <jet-input id="address1"  type="text" class="form-control" v-model="form.address1" />
            <jet-input-error :message="form.errors.address1" class="mt-2" />
          </div>
          <div class="form-group col-sm-6">
            <jet-label for="address2" value="Unit / Suite" />
            <jet-input id="address2"  type="text" class="form-control" v-model="form.address2" />
            <jet-input-error :message="form.errors.address2" class="mt-2" />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-sm-6">
            <jet-label for="city" value="City" />
            <jet-input id="city"  type="text" class="form-control" v-model="form.city" />
            <jet-input-error :message="form.errors.city" class="mt-2" />
          </div>
          <div class="form-group col-sm-6">
            <jet-label for="state" value="State" />
            <jet-input id="state"  type="text" class="form-control" v-model="form.state" />
            <jet-input-error :message="form.errors.state" class="mt-2" />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-6">
            <jet-label for="postcode" value="Zip" />
            <jet-input id="postcode"  type="text" class="form-control" v-model="form.postcode" />
            <jet-input-error :message="form.errors.postcode" class="mt-2" />
          </div>
        </div>

        <jet-button class="px-5" btnStyle="success" icon="fas fa-plus" :disable="form.processing"  @click="addWarehouse">Add Warehouse</jet-button>
      </section>
    </template>
  </layout>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'

import moment from 'moment'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Layout,
    FlashMessages,
    JetInput,
    JetInputError,
    JetLabel,
  },
  props: {
    settings: Array,
    warehouses: Array
  },
  data() {
    return {
      updateForm: this.$inertia.form({
       value: null,
        }),
      form: this.$inertia.form({
        address1: null,
        address2: null,
        city: null,
        state: null,
        postcode: null,  
      }),
    }
  },
  created: function () {
    this.moment = moment;
  },
  methods: {
    updateSetting(e, item) {
      this.updateForm.value = e.target.value;
      this.updateForm.post(this.route('admin.settings.update', item));
    },
    addWarehouse() {
      this.form.post(this.route('admin.settings.addwarehouse'));
    },
  },
}

</script>
